import * as actions from "./actions";

const initialState = {
	item: null,
	loading: {},
	errors: {}
};

const reducer = function(state = initialState, { type }) {
	switch (type) {
		case actions.CREATE_SOLICITATION_CONTRACT: {
			return {
				...state,
				loading: { isCreating: true }
			};
		}
		default: {
			return state;
		}
	}
};

export default reducer;
